
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ExternoComponent } from './externo.component';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';
import { AjustesComponent } from './profile/ajustes/ajustes.component';
import { PassComponent } from './profile/pass/pass.component';
import { FotoComponent } from './profile/foto/foto.component';
import { EventosComponent } from './profile/eventos/eventos.component';
import { AppsInternasComponent } from './home/apps-internas/apps-internas.component';
import { NoaccesibleComponent } from './noaccesible/noaccesible.component';
import { ManualComponent } from './manual/manual.component';


const routes: Routes = [
  {
    path: '',
    component: ExternoComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'no-accesible', component: NoaccesibleComponent },
      {
        path: 'profile/:uid',
        component: ProfileComponent,
        children: [
          { path: '', component: PassComponent },
          { path: 'pass', component: PassComponent },
        ],
      },
      { path: 'ayuda', component: ManualComponent },
      { path: 'appsint/:url', component: AppsInternasComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExternoRoutingModule {}
